
                            import workerSource from "../worker/renderer.worker.js";
                            let cached = null;
                            export async function getWorkerURL() {
                                if (cached) return cached;
                                const blob = new Blob([workerSource], {
                                    type: "application/javascript",
                                });
                                cached = URL.createObjectURL(blob);
                                return cached;
                            }

                            async function getWorkerSource() {
                                return workerSource;
                            }

                            
    function run_single_threaded(workerSource) {
        console.warn("Running perspective in single-threaded mode");
        const channel = new MessageChannel();
        const f = Function("const self = arguments[0];" + workerSource);
        f(channel.port2);
        channel.port2.start();
        return channel.port1;
    }

    export async function initialize(opts) {
        const workerOpts = opts || { type: "module" };
        try {
            if (
                typeof window !== "undefined" &&
                window.location &&
                window.location.protocol &&
                window.location.protocol.startsWith("file")
            ) {
                console.warn(
                    "file:// protocol does not reliably support Web Workers"
                );

                return run_single_threaded(await getWorkerSource());
            }

            const url = await getWorkerURL();
            return new Worker(url, workerOpts);
        } catch (e) {
            console.error(
                "Error instantiating worker; falling back to single-threaded mode",
                e
            );

            return run_single_threaded(await getWorkerSource());
        }
    }


                            export default getWorkerURL;
                        